<div class="wrap">
    <form [formGroup]="ffvLoginForm" (ngSubmit)="onSubmit()">

        <div class="form-group">
            <label for="lastName">N° Licence</label>
            <input class="without_radio" type="text" formControlName="licence" class="form-control"
                (input)="isInactive($event.target.value)" />
        </div>
        <div class="form-group">
            <label for="firstName">Mot de passe</label>
            <input class="without_radio" type="password" formControlName="password" class="form-control"
                (input)="isInactive($event.target.value)" />
        </div>

        <div class="register">
            <button type='submit' [disabled]="loading" [ngClass]="{inactive: !inactive}">
                Confirmer
            </button>
        </div>
        <div class="back" (click)="back()">
            Retour
        </div>
    </form>

</div>